var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          class: ["c-page-header__button--round", _vm.className],
          attrs: {
            id: "search-button",
            "aria-expanded": String(_vm.showSearchPane),
            "aria-controls": "search-pane"
          },
          on: { click: _vm.toggleSearchPane }
        },
        [
          _c("v-icon", { attrs: { name: "icon-search", size: "s" } }),
          _vm._v("\n\t\t‍"),
          _c("span", { staticClass: "t-visually-hidden" }, [
            _vm._v(_vm._s(_vm.searchButtonText))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade" } }, [
        _vm.showSearchPane
          ? _c("div", [
              _c("div", { staticClass: "c-search-pane" }, [
                _c(
                  "form",
                  {
                    ref: "searchForm",
                    staticClass:
                      "c-search-pane__input__wrapper o-width-limiter",
                    attrs: { method: "get", action: _vm.url }
                  },
                  [
                    _c("input", {
                      ref: "searchInput",
                      staticClass: "c-search-pane__input",
                      attrs: {
                        id: "search-pane",
                        name: "q",
                        "aria-label": "huvudsök",
                        type: "text",
                        placeholder: _vm.searchPlaceholder,
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.query },
                      on: { input: _vm.handleOnChange }
                    }),
                    _vm._v(" "),
                    _vm.suggestions.length > 0
                      ? _c(
                          "div",
                          { staticClass: "c-search-pane__suggestion-wrapper" },
                          [
                            _c(
                              "ul",
                              { staticClass: "c-search-pane__suggestion-list" },
                              _vm._l(_vm.suggestions, function(item, index) {
                                return _c("li", { key: index }, [
                                  _c("button", {
                                    staticClass:
                                      "c-search-pane__suggestion-item",
                                    attrs: { type: "button" },
                                    domProps: {
                                      innerHTML: _vm.getHighlight(item)
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleSuggestionSelect(item)
                                      }
                                    }
                                  })
                                ])
                              }),
                              0
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query
                      ? _c(
                          "button",
                          {
                            staticClass: "c-search-pane__clear",
                            attrs: { type: "button", title: "Rensa sökfält" },
                            on: { click: _vm.handleClearInput }
                          },
                          [
                            _c("v-icon", {
                              attrs: { name: "icon-close", size: "xs" }
                            }),
                            _vm._v(" ‍"),
                            _c("span", { staticClass: "t-visually-hidden" }, [
                              _vm._v("rensa sökfält")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "c-search-pane__button",
                        attrs: { type: "submit", id: "searchpaneSubmitButton" },
                        on: { blur: _vm.handleFocusout }
                      },
                      [
                        _c("v-icon", { attrs: { name: "icon-search" } }),
                        _vm._v(" ‍"),
                        _c("span", { staticClass: "t-visually-hidden" }, [
                          _vm._v(_vm._s(_vm.performSearchText))
                        ])
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "c-page-header__overlay c-page-header__overlay--search-pane"
              })
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }